var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.link ? 'sg-link' : 'div',{tag:"component",class:[`chip chip--${_vm.kind}`, { 'chip--outline': _vm.outline , 'chip--is-large':_vm.isLarge }],attrs:{"to":_vm.to}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }